import { Link } from 'react-router-dom';
import { X, Sparkles, Check } from 'lucide-react';

interface UpgradeModalProps {
  open: boolean;
  onClose: () => void;
  reason: string;
  feature?: string;
  highlights?: string[];
}

const DEFAULT_HIGHLIGHTS = [
  'Every module of every path unlocked',
  'Plain-language reading mode',
  'Path completion certificates',
  'Public learner profile and shareable notebook',
  'Export your notebook any time',
];

export default function UpgradeModal({ open, onClose, reason, feature, highlights }: UpgradeModalProps) {
  if (!open) return null;
  const items = highlights && highlights.length > 0 ? highlights : DEFAULT_HIGHLIGHTS;
  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center bg-ink-900/40 px-4"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-lift max-w-md w-full p-7 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute top-4 right-4 text-ink-400 hover:text-ink-700"
        >
          <X className="w-4 h-4" />
        </button>
        <div className="inline-flex items-center gap-2 chip-accent mb-4">
          <Sparkles className="w-3 h-3" /> Pro feature
        </div>
        <h3 className="font-display text-3xl mb-2">{feature || 'Upgrade to Pro'}</h3>
        <p className="text-ink-600 leading-relaxed mb-5">{reason}</p>
        <ul className="space-y-2 mb-6">
          {items.map((h) => (
            <li key={h} className="flex items-start gap-2 text-sm text-ink-700">
              <Check className="w-4 h-4 text-accent-600 mt-0.5 flex-shrink-0" />
              {h}
            </li>
          ))}
        </ul>
        <div className="flex gap-2">
          <Link to="/pricing" className="btn-primary flex-1 justify-center">View plans</Link>
          <button onClick={onClose} className="btn-secondary">Not now</button>
        </div>
      </div>
    </div>
  );
}
